<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle"><a id="page_xv"><b>IMPORTANT NAMES</b></a></p><a id="page_xv">
<p class="hang">Arthur Baylis provided testimony as to the valuation of the Reading Railroad</p>
<p class="hang">Isabel Benham valuation expert for the Reading Railroad</p>
<p class="hang">Charles Bertrand president of the Reading Railroad</p>
<p class="hang">John Brennan chief financial officer for the Reading Railroad</p>
<p class="hang">John Bunting CEO of First Pennsylvania Bank</p>
<p class="hang">Joseph (Joe) L. Castle trustee of the Reading Railroad (succeeding Richardson Dilworth upon Dilworth’s death)</p>
<p class="hang">Lloyd Cutter lawyer representing the Penn Central Railroad</p>
<p class="hang">Richardson (Dick) Dilworth trustee of the Reading Railroad</p>
<p class="hang">William (Bill) Dimeling attorney for the Reading Railroad</p>
<p class="hang">William (Bill) Ditter judge in charge of the Reading Railroad’s reorganization</p>
<p class="hang">Richard (Dick) Duzak accountant with Peat Marwick</p>
<p class="hang">Herbert A. Fogel mentor</p>
</a><p class="hang"><a id="page_xv"></a><a id="page_xvi">Lockwood (Lock) L. Fogg Jr. special counsel and later secretary and general counsel to the Reading Company</a></p><a id="page_xvi">
<p class="hang">John Fowler attorney for the Reading Company</p>
<p class="hang">Jim Frick former Reading Railroad employee (returned to help tie up loose ends after conveyance)</p>
<p class="hang">Henry Friendly chief judge of special court</p>
<p class="hang">William Fuchs managing partner of Obermayer, Rebmann, Maxwell and Hippel</p>
<p class="hang">Jim Gallagher accountant with Peat Marwick</p>
<p class="hang">Alfred (Bill) W. Hesse senior vice president and general counsel, and later president, of the Reading Company</p>
<p class="hang">Tom Keyser chief financial officer of the Reading Railroad after John Brennan</p>
<p class="hang">Andrew (Drew) L. Lewis trustee of the Reading Railroad and later secretary of transportation</p>
<p class="hang">Bernard (Bernie) G. Meltzer real estate broker and local columnist and radio personality</p>
<p class="hang">Christine Nethesheim attorney for the United States Railway Association</p>
<p class="hang">Hugh Scott US senator</p>
<p class="hang">Doug Segal attorney for the United States Railway Association</p>
<p class="hang">Larry Shiekman partner at Pepper, Hamilton &amp; Scheetz, representing Conrail</p>
<p class="hang">James (Jim) Alan Sox assistant to Howard Lewis and former law clerk of Judge William Ditter</p>
</a><p class="hang"><a id="page_xvi"></a><a id="page_xvii">Grant Sprecher head of the Litigation Department at Obermayer, Rebmann, Maxwell and Hippel</a></p><a id="page_xvii">
<p class="hang">Roszel Thomsen judge of special court formed to oversee the railroad’s reorganization</p>
<p class="hang">Stuart Warden former Reading Railroad employee (returned to help tie up loose ends after conveyance)</p>
<p class="hang">Harris Weinstein attorney representing Penn Central’s passenger case</p>
<p class="hang">John Wisdom judge of special court and Fifth Circuit Court of Appeals</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 10_ImportantNames.vue?6780a102